import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Podcastlisting(porps) {

    return (
        <div className="podcast_listing tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
                        <div className="example" data-text="Podcast Ep">
                            <h2>Latest Episodes</h2>
                        </div>
                        <p>We collaborate with entrepreneurs and industry leaders to emphasize the importance of digital
                            transformation. We regularly invite technopreneurs and change leaders to talk about how
                            technology played a crucial role in transforming their businesses and how it helps them
                            scale up with sustainability.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>How To Get Investors To Say “YES” To Your Startup!</h4>
                            <div className="podcast_txt">
                                <p>In episode #06, we are joined by the founder of Slidebean, Jose Caya, to discuss the importance of pitch decks to increase market excitement about your product...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-ep6"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>The Importance of Patents in Entrepreneurship</h4>
                            <div className="podcast_txt">
                                <p>In Episode 5, Abeer Raza sits with the president of American Patent Agency PC, Mr. Daniar Hussain, and Mr.Stephen Hou, a Patent Prosecution Advisor at APA PC...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-ep5"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>What Makes A Successful Entrepreneur From The Lens Of A Coach</h4>
                            <div className="podcast_txt">
                                <p>In episode #04, Tekrevol Co-Founder Abeer Raza sits with Michelle Law, a business consultant with over a decade of experience of coaching entrepreneurs...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-ep4"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );

}


export default Podcastlisting;